import { LANDING_PAGES } from './constants';
import { getWithAuth, postWithAuth } from './api';

async function handleVisit(landingKey, userSession) {
  if (!userSession) {
    return null;
  }

  const pathKey = landingKey || '_signup';
  const activity = LANDING_PAGES.find(p => p.pathKey === pathKey);
  if (!activity || activity.type !== 'visit') {
    console.warn('No valid landing activity found for key:', pathKey);
    return null;
  }

  // Try fetch existing session for this activity
  try {
    const res = await getWithAuth(`/sessions?activity=${activity.id}`, userSession.authToken);
    const data = await res.json();
    if (!res.ok) throw new Error(data?.message || 'Request failed');
    if (data && data[0]) {
      return data[0];  // Return existing session
    }
  } catch (err) {
    console.error('Error fetching sessions:', err);
    return null;
  }

  // Create a new session/visit if none found
  console.log(activity);
  try {
    const res = await postWithAuth(`/stations/${activity.id}/visit`, userSession.authToken, { value: activity.points });
    const data = await res.json();
    if (!res.ok) throw new Error(data?.message || 'Request failed');
    return data;  // Return newly created session
  } catch (err) {
    console.error('Error creating session:', err);
  }
}

export default handleVisit;